<div>
	<ul v-if="products !== null" class="product-grid mb-5 product-grid--4-col">
		<li v-for="(product, index) in products" class="product-grid__item" data-aos-once="true" data-aos="fade-up" :data-aos-delay="50 * index">
			<product-card
				:displayName="product.displayName"
				:productDetailUrl="product.productDetailUrl"
				:availability="product.availability"
				:finish="product.finish"
				:productIndex="index"
				:primaryImageUrl="product.primaryImageUrl"
				:secondaryImageUrl="product.secondaryImageUrl"
				:alternateFinishes="product.alternateFinishes"
				:stockNumber="product.stockNumber"
				:translations="translations"
			/>
		</li>
	</ul>
</div>
